export const BO_ACCEPTED_FILES_TYPE = ".jpg, .png, .xlsx, .pdf, .docx, .doc, .txt, .mp4";
export const BO_ACCEPTED_FILES_LIMIT = 999;
export const BO_MAXIMUM_FILE_SIZE = 52428800; // 5MB in binary
